import { render, staticRenderFns } from "./DiscoveryBoxInstall.vue?vue&type=template&id=00876c9e"
import script from "./DiscoveryBoxInstall.vue?vue&type=script&lang=js"
export * from "./DiscoveryBoxInstall.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryBoxInstall.vue?vue&type=style&index=0&id=00876c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports